export function initCartUpdater(cartCounterWidget: HTMLElement): void {
  window.addEventListener('pageshow', async (event: PageTransitionEvent) => {
    if (!!event.persisted) {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cart = await response.json();

      if (!!cart.item_count) {
        cartCounterWidget.innerText = cart.item_count;
      }
    }
  });
}
